module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEMOLE.3c76d6c6.jpg";